import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'

import TableCellAddress from './TableCellAddress'
import SortableTableHead from '../SortableTableHead'
import { colours } from '../../settings/settings'

const TableMatchSelection = ({
  matches,
  selectedGare,
  setSelectedGare,
  iscrizioniLight,
  selectedSquadra,
  multiple = false,
  showOpponentName = false,
  showAddress = false,
}) => {
  let columns = [
    { label: 'Selezione', sortable: false },
    { label: 'Gara', sortable: false },
    { label: 'Data e Ora', sortable: false },
  ]
  if (showOpponentName)
    columns = [...columns, { label: 'Avversario', sortable: false }]
  if (showAddress)
    columns = [...columns, { label: 'Indirizzo attuale', sortable: false }]

  const opponentName = a => {
    const isSelectedHome = selectedSquadra === a.squadraCasaID
    const isSelectedAway = selectedSquadra === a.squadraTrasfertaID
    const opponent = iscrizioniLight?.find(
      i =>
        (isSelectedHome && i.id === a.squadraTrasfertaID) ||
        (isSelectedAway && i.id === a.squadraCasaID),
    )
    return opponent?.nomeSquadra
  }

  return (
    <TableContainer component={Paper}>
      <Table size='small'>
        <SortableTableHead table={matches} columns={columns} />
        <TableBody>
          {matches?.map((a, index) => {
            const isSelected = selectedGare?.includes(a._id)

            return (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: isSelected
                    ? colours.highlightGreen
                    : colours.white,
                }}
              >
                <TableCell>
                  <Checkbox
                    id={`${a._id}-checkbox`}
                    color='success'
                    checked={!!isSelected}
                    onChange={() => {
                      if (!multiple && isSelected) setSelectedGare()
                      if (!multiple && !isSelected) setSelectedGare([a._id])
                      if (multiple && isSelected)
                        setSelectedGare(selectedGare?.filter(g => g !== a._id))
                      if (multiple && !isSelected)
                        setSelectedGare([...(selectedGare ?? []), a._id])
                    }}
                  />
                </TableCell>
                <TableCell>{a?.numeroGara}</TableCell>
                <TableCell>
                  {a?.data}&nbsp;{a?.ora}
                </TableCell>
                {showOpponentName && <TableCell>{opponentName(a)}</TableCell>}
                {showAddress && <TableCellAddress gara={a} />}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TableMatchSelection
